export default "__VITE_ASSET__K7PiYqeK__"